import { createContext, useState } from "react";

const DatosCompradorContext = createContext();

const DatosCompradorProvider = ({ children }) => {
  const [correoCompradorContext, setCorreoCompradorContext] = useState("");
  const [tiendaAsociadaContext, setTiendaAsociadaContext] = useState("");
  const [tiendaAsociadaAuxiliarContext, setTiendaAsociadaAuxiliarContext] =
    useState(false);
  const [rolContext, setRolContext] = useState("");
  const [idGeneradoContext, setIdGeneradoContext] = useState("");
  const [idbuscadoContext, setIdbuscadoContext] = useState("");
  const [nombreVendedorContext, setNombreVendedorContext] = useState("");
  const [skuContext, setSkucontext] = useState("");
  const [mostrarSelectTienda, setMostrarSelectTienda] = useState(true);
  const resetDatosFolio = () => {
    setIdGeneradoContext("");
    setIdbuscadoContext("");
    setSkucontext("");
  };
  const resetDatos = () => {
    setNombreVendedorContext("");
    setCorreoCompradorContext("");
    setTiendaAsociadaContext("");
    setRolContext("");
    setIdGeneradoContext("");
    setIdbuscadoContext("");
    setSkucontext("");
    setTiendaAsociadaAuxiliarContext(false);
  };

  return (
    <DatosCompradorContext.Provider
      value={{
        nombreVendedorContext,
        setNombreVendedorContext,
        correoCompradorContext,
        setCorreoCompradorContext,
        tiendaAsociadaContext,
        setTiendaAsociadaContext,
        rolContext,
        setRolContext,
        idGeneradoContext,
        setIdGeneradoContext,
        idbuscadoContext,
        setIdbuscadoContext,
        skuContext,
        setSkucontext,
        resetDatosFolio,
        resetDatos,
        tiendaAsociadaAuxiliarContext,
        setTiendaAsociadaAuxiliarContext,
        mostrarSelectTienda,
        setMostrarSelectTienda,
      }}>
      {children}
    </DatosCompradorContext.Provider>
  );
};

export { DatosCompradorContext, DatosCompradorProvider };
